"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crmDeleteApi = crmDeleteApi;
exports.crmDisconnectApi = crmDisconnectApi;
exports.crmDownloadMappingApi = crmDownloadMappingApi;
exports.crmDownloadMappingCCApi = crmDownloadMappingCCApi;
exports.crmGetApi = crmGetApi;
exports.crmImportDataApi = crmImportDataApi;
exports.crmImportMappingApi = crmImportMappingApi;
exports.crmListApi = crmListApi;
exports.crmPauseApi = crmPauseApi;
exports.crmSaveBulkApi = crmSaveBulkApi;
exports.crmTestBulkApi = crmTestBulkApi;
exports.crmUpdateApi = crmUpdateApi;
exports.crmValidateMappingApi = crmValidateMappingApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
function crmListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.crm.list), params);
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function crmGetApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.crm.get), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function crmUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.crm.update), params);
}

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
function crmDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.crm.delete), params);
}

/**
 * disconnect
 * @param payload
 * @returns api response
 * @description this function used to disconnect data.
 */
function crmDisconnectApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.crm.discponnect), params);
}

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause data.
 */
function crmPauseApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.crm.pause), params);
}

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause data.
 */
function crmImportDataApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.crmImport.importData), params);
}

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause data.
 */
function crmValidateMappingApi(payload) {
  return api.createWithParamBody("".concat(_app.default.baseUrl + _dashboard.PlatformService.crmImport.validateMapping), payload.params, payload.data);
}

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause data.
 */
function crmImportMappingApi(payload) {
  return api.createWithParamBody("".concat(_app.default.baseUrl + _dashboard.PlatformService.crmImport.importMapping), payload.params, payload.data);
}

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause data.
 */
function crmDownloadMappingApi(params) {
  return api.getFile("".concat(_app.default.baseUrl + _dashboard.PlatformService.crmImport.downloadMapping), params);
}

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause data.
 */
function crmDownloadMappingCCApi(params) {
  return api.getFile("".concat(_app.default.baseUrl + _dashboard.PlatformService.crmExport.export), params);
}

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause data.
 */
function crmSaveBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.crmFieldMapping.saveBulk), params);
}

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause data.
 */
function crmTestBulkApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.crmFieldMapping.testField), params);
}